__turbopack_context__.v({
  "frame": "IvDdHW_frame",
  "rDot": "IvDdHW_rDot",
  "rDotBottom": "IvDdHW_rDotBottom",
  "rDotLeft": "IvDdHW_rDotLeft",
  "rDotRight": "IvDdHW_rDotRight",
  "rDotTop": "IvDdHW_rDotTop",
  "rFrame": "IvDdHW_rFrame",
  "rLabel": "IvDdHW_rLabel",
  "rValue": "IvDdHW_rValue",
  "readout": "IvDdHW_readout",
  "surface": "IvDdHW_surface",
});
